import dayjs from "dayjs";

/** Human-readable window for a banner row. */
export const windowLabel = (banner) => {
  if (!banner?.startsAt && !banner?.endsAt) return "Винаги";
  const from = banner.startsAt ? dayjs(banner.startsAt).format("D MMM YYYY") : "сега";
  const to = banner.endsAt ? dayjs(banner.endsAt).format("D MMM YYYY") : "без крайна дата";
  return `${from} — ${to}`;
};

/** What a row says this banner does, since a hidden one has no useful text. */
export const bannerSummary = (banner) =>
  banner?.hidden ? "Лентата не се показва" : banner?.text;
